export const WpoAppointmentsRoutes = Object.freeze({
  INTRO: 'wpoAppointmentsIntro',
  CONTACT_DETAILS: 'wpoAppointmentsContactDetails',
  AREA_OF_CONCERN: 'wpoAppointmentsAreaOfConcern',
  LANGUAGE_SELECTION: 'wpoAppointmentsLanguageSelection',
  TIMESLOT_SELECTION: 'wpoAppointmentsTimeslotSelection',
  COUNSELLOR_SELECTION: 'wpoAppointmentsCounsellorSelection',
  APPOINTMENT_TYPE: 'wpoAppointmentsAppointmentType',
  APPOINTMENT_CONFIRMATION: 'wpoAppointmentsAppointmentConfirmation',
  BOOKING_CONFIRMATION: 'wpoAppointmentsBookingConfirmation',
  APPOINTMENT_DETAILS: 'wpoAppointmentsAppointmentDetails',
  APPOINTMENT_CANCELLED: 'wpoAppointmentsAppointmentCancelled',
  APPOINTMENT_HISTORY: 'wpoAppointmentsAppointmentHistory',
});

export const WPO_BACK_BUTTON_DATA_HOOK = 'wpo-appointments-go-back';
